'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.accordionToggle = undefined;

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var accordionToggle = exports.accordionToggle = function accordionToggle($el) {
	$el.toggleClass('is-open');
	$el.next($(_Dom2.default.accordionText)).slideToggle();
};